import React, { useState } from 'react';
import { Icon1 } from './Icon1';
import { Icon2 } from './Icon2';
export interface TestimonialProps {
  /** Optional data-id for component identification */
  'data-id'?: string;
  /** User's name */
  userName: string;
  /** User's job title or role */
  userTitle: string;
  /** URL of the user's image */
  imageUrl: string;
  /** Button text for the CTA */
  buttonText?: string;
  /** Button click handler */
  onButtonClick?: () => void;
}
export const Testimonial: React.FC<TestimonialProps> = ({
  'data-id': dataId,
  userName,
  userTitle,
  imageUrl,
  buttonText = 'Watch Demo',
  onButtonClick
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return;
};